import { render } from "./StrukturOrganisasi.vue?vue&type=template&id=556c4ef5"
import script from "./StrukturOrganisasi.vue?vue&type=script&lang=js"
export * from "./StrukturOrganisasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__